import { Box, Button, NoticeBox, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import {
  FixedBreakInputs,
  FlexibleBreakInputs,
  SemiFlexibleBreakInputs,
} from 'modules/shift_management/components/ShiftManagement/PlannedBreaks/FormInputs'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

interface Props {
  plannedBreakForms: PlannedBreakForm[]
  validationParams: {
    startAt?: moment.Moment
    endAt?: moment.Moment
    duration?: number
  }
  onDelete: (form: PlannedBreakForm) => void
}

const PlannedBreaks = ({ plannedBreakForms, validationParams, onDelete }: Props) => {
  return (
    <>
      {plannedBreakForms.map((form, index) => {
        if (!!form.get('break_configuration.archived').value) {
          return (
            <Box key={index} flexDirection="row" gap="s16">
              <NoticeBox
                message={i18n.t('shift_management.planned_breaks.archived.warning_custom')}
                borderRadius={{ all: 'abs008' }}
              />
              <Box>
                <Button type="secondary" onClick={() => onDelete(form)} iconName="delete" />
              </Box>
            </Box>
          )
        }

        const error = form.validationError(validationParams)

        return (
          // FIXME: We shouldn't be using indexes as keys, but can't use id as key since new forms won't have one :_D
          <Box key={index} gap="s8">
            <Box flexDirection="column" gap="s8">
              <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
                <Box flexDirection="row" gap="s8" alignItems="center">
                  <Text.Normal size="200" weight="medium" color="grey800">
                    {form.get('break_configuration.name').value}
                  </Text.Normal>
                  <Box width="fit-content">
                    <Tag
                      type={
                        form.get('break_configuration.paid').value
                          ? Tag.Types.lime
                          : Tag.Types.malibu
                      }
                    >
                      {form.get('break_configuration.paid').value
                        ? i18n.t('company_settings.time.breaks.paid')
                        : i18n.t('company_settings.time.breaks.unpaid')}
                    </Tag>
                  </Box>
                </Box>

                <Box>
                  <Button type="secondary" onClick={() => onDelete(form)} iconName="delete" />
                </Box>
              </Box>
              <Box flexDirection="row" alignItems="center" gap="s16" width="s300">
                {/* Use showNotice once the refactor is done with the new layout of breaks */}
                {form.isFlexible && <FlexibleBreakInputs form={form} error={error} />}
                {form.isFixed && <FixedBreakInputs form={form} error={error} />}
                {form.isSemiFlexible && <SemiFlexibleBreakInputs form={form} error={error} />}
              </Box>
            </Box>
          </Box>
        )
      })}
    </>
  )
}
export default observer(PlannedBreaks)
